module.exports = __webpack_public_path__ + "static/media/project1j.17f94b26.jpg";